export default function CrownBannerSection() {
  return (
    <section id="crown-banner" className="py-12 bg-gradient-to-r from-amber-50 to-orange-50 border-y border-amber-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-3">
            <i className="ri-vip-crown-fill text-amber-500 text-2xl"></i>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">The best advertisement and job post, factory and buyer, and business opportunities</h2>
            <i className="ri-vip-crown-fill text-amber-500 text-2xl"></i>
          </div>
          <p className="text-gray-500 text-sm">Premium featured listings from top employers and advertisers</p>
        </div>

        {/* Featured Banner */}
        <div className="relative rounded-2xl overflow-hidden mb-6 cursor-pointer group">
          <img
            src="https://public.readdy.ai/ai/img_res/0d0fbec784e9f355d5bfad8b6e01cfda.jpg"
            alt="Crown Featured Banner"
            className="w-full h-48 md:h-64 object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center px-8 md:px-12">
            <div>
              <span className="inline-block bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3">CROWN FEATURED</span>
              <h3 className="text-white text-2xl md:text-4xl font-bold mb-2">Advertisements &amp; Job Post Exhibition</h3>
              <p className="text-white/80 text-sm md:text-base mb-4">Logistics Advertising, Warehouse Dropshipping Services &amp; Global Business Opportunities — all in one place.</p>
              <button className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-2.5 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap">
                Register Free
              </button>
            </div>
          </div>
        </div>

        {/* Quick Action Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: "ri-briefcase-line", title: "Post a Job", desc: "Reach 2M+ seekers", color: "bg-amber-500", action: "Post Now" },
            { icon: "ri-advertisement-line", title: "Place an Ad", desc: "500K+ daily views", color: "bg-orange-500", action: "Advertise" },
            { icon: "ri-file-user-line", title: "Upload Resume", desc: "Get discovered fast", color: "bg-rose-500", action: "Upload" },
            { icon: "ri-building-2-line", title: "Company Profile", desc: "Build your brand", color: "bg-stone-700", action: "Create" },
          ].map((card) => (
            <div
              key={card.title}
              className="bg-white rounded-xl p-5 flex flex-col items-center text-center cursor-pointer hover:shadow-md transition-all duration-200 hover:-translate-y-1 border border-stone-100"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${card.color} mb-3`}>
                <i className={`${card.icon} text-white text-xl`}></i>
              </div>
              <div className="font-semibold text-gray-900 text-sm mb-1">{card.title}</div>
              <div className="text-gray-500 text-xs mb-3">{card.desc}</div>
              <button className="text-xs font-semibold text-amber-600 hover:text-amber-700 cursor-pointer whitespace-nowrap">
                {card.action} &rarr;
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
